import React from 'react'
import * as S from './style';
import { ProfileImage, SpaceDiv } from 'components';

import ProfileImageSample from 'assets/img/profile/img_profile_example.png';

export default function ProfilePopupContents() {
  return (
    <S.ContentsContainer>
      <S.ProfileExampleWrapper>
        <ProfileImage size={'XL'} background={ProfileImageSample} />
      </S.ProfileExampleWrapper>
      <S.ProfileGuideWrapper>
        위의 사진을 참고하시어 차량과 함께 찍은 본인 사진을 등록해주세요. <br />
        고객님께 보이는 대표 사진이 됩니다.
      </S.ProfileGuideWrapper>
      <S.ProfileGuideWrapper padding={'12px 0px'}>
        예시 사진과 아래 안내 사항을 참고해주세요.
      </S.ProfileGuideWrapper>
      <S.InformationList
        margin={'0px'}
        hasNotFirstLastChildPadding={true}
        listStyleImageType={'circle'}
        itemPadding={'14px 0px 14px 17px'}
      >
        <S.InformationItem>
          운전석 문 옆에서 포즈를 취해주세요.
        </S.InformationItem>
        <S.InformationItem>
          마스크, 문신, 주머니 손에 넣은 사진은 자제 부탁드립니다. <br />
          (사진 예시 참고 부탁드립니다. 차량 정면 X, 뒷면  X)
        </S.InformationItem>
        <S.InformationItem>
          배경 차량은 약 15도~45도 각도로 나오게 해주세요.
        </S.InformationItem>
      </S.InformationList>
      <SpaceDiv height={12} />
      <S.ProfileGuideWrapper>
        아래 항목에 해당할 경우에는 승인되지 않습니다.
      </S.ProfileGuideWrapper>
      <S.InformationList
        margin={'0px'}
        hasNotFirstLastChildPadding={true}
        listStyleImageType={'x'}
        itemPadding={'14px 0px 14px 17px'}
      >
        <S.InformationItem>
          안내 사항에 적합하지 않은 사진을 등록한 경우
        </S.InformationItem>
        <S.InformationItem>
          프로필 사진이 아닌 로고 사진을 업로드한 경우
        </S.InformationItem>
        <S.InformationItem>
          업체 광고 및 연락처를 노출한 경우
        </S.InformationItem>
      </S.InformationList>
      <SpaceDiv height={12} />
    </S.ContentsContainer>
  );
}
